import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Modal from "../../modal/Modal";
import { alertError, alertInfo, toastInfo, confirm } from "actions/ui";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import { focusChannel, openChannel } from "actions/ui";
import { addChannel } from "actions/application";
import { loadPastMessages } from "actions/messages";
import {Scrollbar} from "react-scrollbars-custom";

class ChannelsBrowse extends React.Component {

	constructor(props, context) {
		super(props, context);

		this.state = {
			modalOpen: false,
			...this.getCleanState()
		}

		this.openModal = this.openModal.bind(this);
		this.searchChannels = this.searchChannels.bind(this);
		this.renderSearchResult = this.renderSearchResult.bind(this);
		this.joinChannel = this.joinChannel.bind(this);
	}

	getCleanState() {
		return {
			search: ''
		}
	}

	openModal(e) {
		e.preventDefault();
		this.setState({ modalOpen: true, ...this.getCleanState() });
	}

	componentDidUpdate(prevProps) {
		if (!this.state.modalOpen) {
			return;
		}
		const joinChannelFailure = this.props.requestChannelMembership !== prevProps.requestChannelMembership && this.props.requestChannelMembership && this.props.requestChannelMembership.success === false;
		const joinChannelSuccess = this.props.requestChannelMembership !== prevProps.requestChannelMembership && this.props.requestChannelMembership && this.props.requestChannelMembership.success === true;
		const addUserChannelFailure = this.props.addUserChannel !== prevProps.addUserChannel && this.props.addUserChannel && this.props.addUserChannel.success === false;
		const addUserChannelSuccess = this.props.addUserChannel !== prevProps.addUserChannel && this.props.addUserChannel && this.props.addUserChannel.success === true;

		if (joinChannelFailure) {
			this.props.alertError(this.props.requestChannelMembership.error);
			this.props.clearUserCommand('requestChannelMembership');
		}
		if (joinChannelSuccess) {
			this.props.toastInfo(this.props.i18n.requestSent);
			this.props.clearUserCommand('requestChannelMembership');
		}
		if (addUserChannelFailure) {
			this.props.alertError(this.props.addUserChannel.error);
			this.props.clearUserCommand('addUserChannel');
		}
		if (addUserChannelSuccess) {
			const channel = this.props.addUserChannel.result.channel;
			this.props.addChannel(channel);
			this.props.openChannel(channel.id);
			this.props.focusChannel(channel.id);
			this.props.clearUserCommand('addUserChannel');
			this.props.toastInfo(this.props.i18n.channelAdded);
		}
	}

	componentWillUnmount() {
		this.props.clearUserCommand('searchChannels');
		if (this.searchTimer) {
			clearTimeout(this.searchTimer);
			this.searchTimer = null;
		}
	}

	searchChannels() {
		if (this.searchTimer) {
			clearTimeout(this.searchTimer);
			this.searchTimer = null;
		}
		if (this.state.search) {
			this.searchTimer = setTimeout(function() { this.searchChannelsReal(); }.bind(this), 400);
		}
	}

	searchChannelsReal() {
		this.props.sendUserCommand('searchChannels', 'searchChannels', { search: this.state.search });
	}

	renderSearchResult(entry, index) {
		let status = this.props.i18n.freeToJoin;
		let actionName = this.props.i18n.openChannel;
		if (entry.channel.type === 'private') {
			if (entry.member) {
				status = this.props.i18n.channelMember;
			} else {
				status = this.props.i18n.notMember;
				actionName = this.props.i18n.askToJoin;
			}
		}

		return <tr key={ index }>
			<td>{ entry.channel.name }</td>
			<td>{ entry.channel.type }</td>
			<td>{ status }</td>
			<td><a href="#" onClick={ e => this.joinChannel(e, entry) }>{ actionName }</a></td>
		</tr>
	}

	joinChannel(e, entry) {
		e.preventDefault();

		if (entry.channel.type === 'private' && !entry.member) {
			this.props.confirm(this.props.i18n.askChannelAdmin, function() {
				this.props.sendUserCommand('requestChannelMembership', 'requestChannelMembership', { channelId: entry.channel.id });
			}.bind(this));
		} else {
			this.props.sendUserCommand('addUserChannel', 'addUserChannel', { channelId: entry.channel.id });
		}
	}

	render() {
		if (!this.props.userRights.searchChannels) {
			return null;
		}

		return <React.Fragment>
			<a href="#" className="wcFunctional" title={ this.props.i18n.browseChannels } onClick={ this.openModal }><span className="wcIcon wcIconZoom" />{ this.props.label ? this.props.i18n.browseChannels : '' }</a>
			<Modal
				open={ this.state.modalOpen }
				onClose={ e => this.setState({ modalOpen: false }) }
				title={ this.props.i18n.browseChannels }
				size="lg"
				closable={ true }
				closeOnDocumentClick={ false }
			>
				<div className="wcFormRow">
					<label>{ this.props.i18n.searchChannels }: </label>
					<input
						className="wcFormControl"
						type="text"
						maxLength={ 200 }
						value={ this.state.search }
						onChange={ e => this.setState({ search: e.target.value }, this.searchChannels)}
					/>
				</div>
				{ this.state.search &&
					<div className="wcFormRow">
						<label>{ this.props.i18n.foundChannels }: </label>
						<div className="wcFormControlBorder wcHeight10 wcPadding1">
							{this.props.channels && this.props.channels.inProgress && <span className="wcMargin1">{ this.props.i18n.searching } ...</span> }
							{this.props.channels && !this.props.channels.inProgress && this.props.channels.result.entries.length === 0 && <span className="wcMargin1">{ this.props.i18n.noChannels }</span> }
							{this.props.channels && this.props.channels.result && this.props.channels.result.entries.length > 0 &&
								<Scrollbar>
									<table className="wcTable">
										<thead>
											<tr>
												<th>{ this.props.i18n.channelName }</th>
												<th>{ this.props.i18n.channelType }</th>
												<th>{ this.props.i18n.channelStatus }</th>
												<th>{ this.props.i18n.channelActions }</th>
											</tr>
										</thead>
										<tbody>
											{this.props.channels.result.entries.map( (entry, index) => this.renderSearchResult(entry, index) )}
										</tbody>
									</table>
								</Scrollbar>
							}
						</div>
					</div>
				}

			</Modal>
		</React.Fragment>
	}

}

ChannelsBrowse.propTypes = {
	configuration: PropTypes.object.isRequired,
	label: PropTypes.bool
};

export default connect(
	(state) => ({
		userRights: state.application.user.rights,
		configuration: state.configuration,
		i18n: state.application.i18n,
		channels: state.commands.sent.searchChannels,
		requestChannelMembership: state.commands.sent.requestChannelMembership,
		addUserChannel: state.commands.sent.addUserChannel
	}),
	{ sendUserCommand, clearUserCommand, alertError, alertInfo, focusChannel, openChannel, addChannel, toastInfo, confirm, loadPastMessages }
)(ChannelsBrowse);